import { FC } from 'react'
import { AppListSize, Item } from './Item'
import { useSelector } from 'react-redux'
import { userSlice } from '@wellesley/user'
import { appsListSlice } from './appsListSlice'

export type AppsListProps = {
  size: AppListSize
}

export const AppsList: FC<AppsListProps> = ({ size }) => {
  const { selectList, selectActiveGroupName, selectEntryPoint } =
    appsListSlice.selectors
  const list = useSelector(selectList)
  const groupname = useSelector(selectActiveGroupName)
  const entryPoint = useSelector(selectEntryPoint)
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)

  if (!list) return null

  return (
    <div className="max-h-[315px] overflow-auto text-sm  text-slate-700">
      <div className="mt-1 grid gap-3">
        {list.map((app) => (
          <Item
            key={app.id}
            app={app}
            size={size}
            username={currentUser?.username}
            groupname={groupname || undefined}
            entryPoint={entryPoint}
          />
        ))}
      </div>
    </div>
  )
}
